import React from 'react'
import { Pagination, Select, Typography, Input, Row, Col, Icon } from 'antd';
import BoxNews from '../../../../components/user/BoxNews'
import { Queries, Mutations } from '../../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../../components/user/Container'
import NewsPage from '../../../../components/user/NewsPage'
import ModalErrors from '../../../../components/user/ModalErrors'

// import news1 from '../../../assets/images/news/news1-n.jpg'
// import news2 from '../../../assets/images/news/news2-n.jpg'
// import news3 from '../../../assets/images/news/news3-n.jpg'
// import picbanner1 from '../../../assets/images/banner/picbanner1.jpg'
// import picbanner2 from '../../../assets/images/banner/picbanner2.png'
// import picbanner3 from '../../../assets/images/banner/picbanner3.png'

const { Option } = Select;
const { Text, Title } = Typography
const { Search } = Input;
const options = [
	{ value: "ALL", name: 'ทั้งหมด' },
	{ value: "NEWS", name: 'ข่าว' },
	{ value: "ANNOUNCEMENT", name: 'ประกาศ' },
	{ value: "EVENT", name: 'กิจกรรม' },
	// { value: "PUBLIC_RELATIONS", name: 'ประชาสัมพันธ์' },
	// { value: "ABOUTUS", name: 'เกี่ยวกับเรา' },
];

class News extends React.Component {
	state = {
		type: "ALL",
		detailPost: [],
		headpost: null,
		current: 1,
		// picnews: [news1, news2, news3],
		offset: 0,
		limit: 3,
		//////////////////////addmodalINTERNAL_SERVER_ERROR
		showModalErrors: false,
		search:null,
		preload:true
	};


	fetchListPostAll = async (search) => {
		const { client } = this.props
		const { offset, limit } = this.state

		this.setState({
			preload: true
		})


		const { data, errors } = await client.query({
			query: Queries.fetchListPost,
			variables: { 
				offset, 
				limit,
				search,
				category: "PROVIDENTFUND"
			},
		})

		if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
			await this.setState({
				showModalErrors: true
			})
		} else {
			if (data != null) {
				if (!this.state.headpost) {
					this.setState({ headpost: data.fetchListPost.data[0] })
					// console.log(data.fetchListPost.data[0].bannerLink);
				}
				await this.setState({ 
					detailPost: data,
					preload: false
				})
			}
		}
	}

	fetchListPostType = async (search) => {
		const { client } = this.props
		const { type, offset, limit } = this.state

		this.setState({
			preload: true
		})

		const { data, errors } = await client.query({
			query: Queries.fetchListPost,
			variables: { 
				type, 
				offset, 
				limit, 
				search,
				category: "PROVIDENTFUND"
			},
		})
		// console.log("data.fetchListPost.total",data.fetchListPost.total);

		//////////////////////addmodalINTERNAL_SERVER_ERROR
		if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
			await this.setState({
				showModalErrors: true
			})
		}
		// console.log(" ", data);

		await this.setState({ 
			detailPost: data,
			preload: false
		})
	}

	changetypenew = async (value) => {
		await this.setState({
			type: value,
			current: 1,
			offset: 0,
			search:null
		})
		if (value == "ALL") {
			this.fetchListPostAll('')
		} else {
			this.fetchListPostType('')
		}
	}

	onChangePage = async page => {
		const { type, limit, search } = this.state
		let newoffset = limit * (page - 1)
		await this.setState({
			current: page,
			offset: newoffset,
		});
		if (type == "ALL") {
			this.fetchListPostAll(search)
		} else {
			this.fetchListPostType(search)
		}
	};

	onSearchForm = async (value) =>{
		const { type, limit } = this.state

		await this.setState({
			current: 1,
			offset: 0,
			search: value
		})

		if (type == "ALL") {
			this.fetchListPostAll(value)
		} else {
			this.fetchListPostType(value)
		}
	}


	async componentDidMount() {
		if (window.outerWidth <= 800) {
			await this.setState({ limit: 1 })
		}
		this.fetchListPostAll()
	}

	render() {
		const { picnews, detailPost, current, limit, showModalErrors, search, preload } = this.state
		const { history, location, match, staticContext } = this.props
		// const picbanner = [picbanner1]
		const option = options.map(options1 => (
			<Option key={options1.value}>{options1.name}</Option>
		))

		var total = 0
		if (detailPost.fetchListPost) {
			total = detailPost.fetchListPost.total
		}
		return (
			<Container match={match}>
				{/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
				{
					this.state.showModalErrors &&
					<ModalErrors />
				}
				{/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
				{/* <NewsPage
					picbanner={picbanner}
					headpost={this.state.headpost}
					readmore={this.readmore}
				/> */}
				<div className="pt-4">
					<Row gutter={16} type="flex" justify="space-between" align="top">
						<Col span={12}>
							<Text className="" style={{ fontSize: 17, width:"10%" }} >เลือกประเภทข่าวสาร:</Text>
							<Select defaultValue="ทั้งหมด" key="original" style={{ marginLeft: 30, width: "50%" }} onChange={this.changetypenew}>
								{option}
							</Select>
						</Col>
						<Col span={12}>
							<Text style={{ fontSize: 17 }} >ค้นหา:</Text>
							<Search
								value={search}
								placeholder="ค้นหา"
								onChange={ e => this.setState({
									search : e.target.value
								}) }
								onSearch={value => this.onSearchForm(value)}
								style={{ marginLeft: 30, width: "70%" }}
							/>
						</Col>
					</Row>
				</div>
				{
					preload &&
						<div className="pt-4 mt-3" style={{ textAlign: 'center', borderRadius: "10px", height: "130px" }}>
							<Icon type="loading" />
						</div>
					||
					total > 0 &&
					<>
						<div className="pt-4 mt-3">
							<BoxNews
								// picnews={picnews}
								detailBox={detailPost}
								limit={limit}
								pathLink={"Fund"}
							/>
						</div>
						{
							detailPost.fetchListPost &&
							<Pagination className="pt-4 paginationred" style={{ textAlign: 'right' }} current={current} onChange={this.onChangePage} defaultCurrent={1} total={detailPost.fetchListPost.total} pageSize={limit} />
						}
					</>
					||
					<>

						<div style={{ marginTop:"50px", textAlign: 'center', borderRadius: "10px", height: "70px", backgroundColor: "white" }}>
							<div style={{ padding: "20px" }}>
								<Text className="color-gray" style={{ fontSize: '20px' }} >ไม่พบข้อมูล</Text>
							</div>
						</div>
					</>
				}

			</Container>
		)
	}
}

News.propTypes = {
	//
}

export default withApollo(News)